// src/components/webinar_funnel/sections/CampaignPerformance.jsx
import React, { useState } from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import { useCampaignTableFilters } from '../../../../hooks/useCampaignTableFilters';
import { SCALING_TYPES } from '../../../../utils/heatMapUtils';
import TableControls from './TableControls';
import TableSummary from './TableSummary';
import CampaignTable from './CampaignTable';

const CampaignPerformance = ({ data }) => {
  const [loading]    = useState(false);
  const filters      = useCampaignTableFilters(data);
  const [heatmapEnabled,  setHeatmapEnabled]  = useState(false);
  const [scalingType,     setScalingType]      = useState(SCALING_TYPES.COLUMN_WISE);

  if (loading) {
    return (
      <div className="p-10 flex items-center justify-center gap-3 text-grey-500">
        <ArrowPathIcon className="w-5 h-5 animate-spin text-brand-500" />
        <span className="text-sm">Loading campaign data…</span>
      </div>
    );
  }

  return (
    <div className="space-y-0">
      <TableControls
        {...filters}
        data={data}
        heatmapEnabled={heatmapEnabled}
        onHeatmapToggle={() => setHeatmapEnabled((v) => !v)}
        scalingType={scalingType}
        onScalingTypeChange={setScalingType}
      />

      <TableSummary data={filters.filteredData} />

      <CampaignTable
        data={filters.filteredData}
        heatmapEnabled={heatmapEnabled}
        onHeatmapToggle={setHeatmapEnabled}
        scalingType={scalingType}
        onScalingTypeChange={setScalingType}
      />
    </div>
  );
};

export default CampaignPerformance;